import React from 'react'
import w from 'lib/styleguide/widgets.scss'
import cx from 'classnames'
import _ from 'lodash'
import {CoreLink} from 'common/CoreLink'

const availableVariations = ['link', 'small', 'primary', 'danger', 'secondary', 'facebook']

const getCTATypeClass = (props) => {
  // find the first variation that occurs in props
  const variations = availableVariations.filter(v => props[v])
  return variations.length > 0
    ? variations.map(v => w[v + 'CTA']).join(' ')
    : w.primaryCTA
}
// there's a reason you can't inject a className here. just use a wrapper.
// this is not a stateless component in order to enable refs
export class CTA extends React.PureComponent {
  static defaultProps = {
    margins: true
  }
  render () {
    const {inline, style, margins, disabled, button, className, ...props} = this.props
    const type = getCTATypeClass(props)
    const cn = cx(
      w.CTA,
      inline && w.inlineCTA,
      type,
      className,
      disabled && w.disabled
    )
    // support margins={false} AND style overrides
    const _style = margins
      ? style
      : {margin: '0 0', ...style}
    const safeProps = _.omit(props, availableVariations)
    const allProps = {className: cn, style: _style, ...safeProps}
    return button ? <button {...allProps} /> : <CoreLink {...allProps} />
  }
}
